"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
require("../icon");
//@ts-ignore
require("../theme.ts");
var Avatar = /** @class */ (function (_super) {
    __extends(Avatar, _super);
    function Avatar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Avatar.prototype.render = function (props) {
        return (omi_1.h("div", __assign({}, omi_1.extractClass(props, 'm-avatar', {
            'square': props.square
        }), { style: {
                width: props.size + 'px',
                height: props.size + 'px',
                backgroundColor: props.backgroundColor,
                lineHeight: props.size + 'px'
            } }), props.icon ?
            omi_1.h("i", { class: "material-icons mdc-icon-button__icon", style: { lineHeight: props.size + 'px', color: props.color } }, props.icon) : (props.src ?
            omi_1.h("img", { alt: props.alt, src: props.src }) :
            props.children ? props.children : this.innerHTML)));
    };
    Avatar.css = css;
    Avatar.defaultProps = {
        size: 40,
        color: 'white',
        backgroundColor: '#ccc'
    };
    Avatar.propTypes = {
        alt: String,
        src: String,
        size: Number,
        square: Boolean,
        icon: String,
        color: String,
        backgroundColor: String
    };
    Avatar = __decorate([
        omi_1.tag('m-avatar')
    ], Avatar);
    return Avatar;
}(omi_1.WeElement));
exports.default = Avatar;
